import { useScroll } from '../hooks/useScroll';
import { useEffect } from 'react';
import { useDocReader, useDocReaderDispatch } from '../store/docReaderContext';

let DISABLE_SCROLL_HIDE_TOOLBAR = false;
// 全屏时，向下滑动docContainer时，隐藏toolbar, 向上滑动docContainer时，显示toolbar
export default function useScrollingHideToolbar() {
    const [state] = useDocReader();
    const dispatch = useDocReaderDispatch();
    const { docContainerRef, screenState } = state;
    const { scrollingUp, scrollingDown } = useScroll({
        containerRef: docContainerRef,
    });
    useEffect(() => {
        if (DISABLE_SCROLL_HIDE_TOOLBAR || screenState !== 'full') {
            return;
        }
        if (scrollingDown) {
            dispatch({ type: 'toolbarHide' });
        }
        if (scrollingUp) {
            dispatch({ type: 'toolbarShow' });
        }
    }, [scrollingDown, scrollingUp, screenState]);
    return {
        enable: () => {
            DISABLE_SCROLL_HIDE_TOOLBAR = false;
        },
        disable: () => {
            DISABLE_SCROLL_HIDE_TOOLBAR = true;
        },
    };
}
